// sample for handle encrypt file
import CryptoUtil from './CryptoUtil.js'

let CryptoUtilFile = {
  // 加密文件
  // sampleCode (file, password) {
  //   let encryptedFile = await encryptFile(file, encryptPassword)
  //   CryptoUtil.arrayBufferToFileDownload('abc.doc', encryptedFile)
  // }
  //
  async encryptFile (file, password) {
    const arrayBuffer = await file.arrayBuffer()
    const unit8Array = new Uint8Array(arrayBuffer)
    let encryptedArrayBuffer = await CryptoUtil.PGPTool.encryptArrayBufferWithPassword(unit8Array, password)
    let blob = new Blob([encryptedArrayBuffer], { type: 'application/octet-stream' })
    return blob
  },
  async decryptFile (encryptedFile, password, fileType) {
    const encryptedArrayBuffer = await encryptedFile.arrayBuffer()
    const encryptedUnit8Array = new Uint8Array(encryptedArrayBuffer)
    let decryptedArrayBuffer = await CryptoUtil.PGPTool.decryptArrayBufferWithPassword(encryptedUnit8Array, password)
    let tFileType = fileType || 'application/octet-stream'
    return new Blob([decryptedArrayBuffer], { type: tFileType })
  }
}

export default CryptoUtilFile
